<template>
  <component
    ref="inputRef"
    :is="isMultiline ? 'textarea' : 'input'"
    class="Input"
    :value="modelValue"
    v-bind="{name, enterkeyhint}"
    :disabled="isDisabled"
    :required="isRequired"
    :data-1p-ignore="!is1PasswordEnabled ? '' : undefined"
    @input="modelValue = $event.target.value"
  />
</template>

<script lang="ts" setup>
import { onMounted, useTemplateRef } from "vue";

const modelValue = defineModel<string | number | null>({
  required: true,
});

const {
  shouldAutoFocus = false,
} = defineProps<{
  name: string,
  isDisabled?: boolean,
  isRequired?: boolean,
  is1PasswordEnabled?: boolean,
  shouldAutoFocus?: boolean,
  isMultiline?: boolean,
  enterkeyhint?: string,
}>();

const inputRef = useTemplateRef<HTMLInputElement>("inputRef");

onMounted(() => {
  if (inputRef.value && shouldAutoFocus) {
    inputRef.value.focus();
  }
});
</script>

<style lang="scss" scoped>
.Input {
  width: 100%;

  border: none;
  border-radius: inherit;
  outline: none;
  background: none;
  color: inherit;
  appearance: none;

  font: var(--fontWeightNormal) 18px / 1 var(--fontFamilyMono);
  font-variant-ligatures: none;
}
</style>
